module.exports = __webpack_public_path__ + "img/pricing-img-lg.b186a903.svg";